import { createRoute, redirect } from "@tanstack/react-router";
import { getToken } from "@/utils/auth/helpers";
import { Route } from "./__root";

export const moeRedirectRoute = createRoute({
  getParentRoute: () => Route,
  path: "/moe-redirect",
  beforeLoad: () => {
    if (getToken()) {
      throw redirect({ to: "/", replace: true });
    }
    throw redirect({ to: "/login", replace: true });
  },
});
